import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import Logout from './../Logout/LogoutComponent';
import './Dashboard.css';
import routes from './../../routes/routes';

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate(routes.LOGIN);
    }
  }, [navigate]);

  return (
    <Container className="text-center mt-5">
      <Row>
        <Col>
          <h2>Dashboard</h2>
        </Col>
      </Row>
      {location.state && location.state.successMessage && (
        <Row className="justify-content-center">
          <Col md={8}>
            <Alert variant="success">{location.state.successMessage}</Alert>
          </Col>
        </Row>
      )}
      <Row className="justify-content-center mt-4">
        <Col xs={6} md={6} lg={3} className="mb-3">
          <Card className="custom-card">
            <a href={routes.MASTER_SUPPRESSION} className="btn btn-primary">
              <Card.Body>
                <Card.Title>Master Suppression</Card.Title>
              </Card.Body>
            </a>
          </Card>
        </Col>
        {/* <Col xs={6} md={6} lg={3} className="mb-3">
          <Card className="custom-card">
            <a href={routes.MEGAN_SUPPRESSION} className="btn btn-primary">
              <Card.Body>
                <Card.Title>Megan Suppression</Card.Title>
              </Card.Body>
            </a>
          </Card>
        </Col> */}
      </Row>
      <Row>
        <Col className="text-right">
          <Logout />
        </Col>
      </Row>
    </Container>
  );
};

export default Dashboard;
